import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../app/providers/auth.service';

@Injectable()
export class ApiHttpInterceptor implements HttpInterceptor {

  /**
   * Standard Angular Constructor.
   *
   * @ignore
   */
  constructor(
    /* eslint-disable */
    public router: Router,
    public authService: AuthService
    /* eslint-disable */
  ) {
  }

  /**
   * Gets and returns the headers for the current request.
   *
   * @arg {boolean} isLoginRequest Defines whether this is a login request (true) or not.
   * @return {any} Returns the headers for the request.
   */
  private getHeaders(isLoginRequest: boolean) {
    const headers: any = {};
    headers.Accept = 'application/xml';

    if (!isLoginRequest && this.authService.getAuthKey()) {
      headers.Authorization = this.authService.getAuthKey();
    }
    return headers;
  }

  /**
   * Processes an Http request.
   *
   * @arg {HttpRequest<any>} req The HttpRequest.
   * @arg {HttpHandler} next The handler to transform the request into streams of Http events.
   * @return {HttpEvent<any>} The body of the request is returned if successful otherwise
   * an error is returned.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;

    const isApiRequest = request.url.startsWith('/');
    const isLoginRequest = request.url.indexOf('login') > -1;

    if (isApiRequest) {
      request = request.clone({
        url: `${environment.apiUrl}${request.url}`,
        setHeaders: this.getHeaders(isLoginRequest)
      });
    }
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.headers.has('Authorization')) {
            this.authService.setAuthKey(event.headers.get('Authorization'));
          }

          if (!event.body) {
            throw new EmptyApiSuccessResponse();
          }
          if (!isApiRequest) {
            return event;
          }

          return event.clone({
            body: event.body
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const loginRoute = '/login';
        // If 401 received or emptyResponse (indicates session expired), redirect to login page
        if ((error.status === 401 || error instanceof EmptyApiSuccessResponse) && this.router.url !== loginRoute) {
          this.router.navigate([loginRoute]);
        } else {
          return throwError(error);
        }
      })
    );
  }
}

/**
 * A class to label an Empty api Success Response as an error.
 */
class EmptyApiSuccessResponse extends Error {

  /**
   * Standard Angular Constructor
   *
   * @ignore
   */
  constructor() {
    super();
  }
}
